export function StaffBrandHeader({ brand }: { brand: string }) {
  return (
    <div className="mb-8 flex items-center gap-2.5">
      <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary text-body-sm text-primary-foreground">
        {brand.slice(0, 1)}
      </span>
      <span className="text-body-sm text-foreground">{brand}</span>
    </div>
  )
}
